import alertsIcon from "../../assets/ais_new_images/alerts.svg";
import speedIcon from "../../assets/ais_new_images/speed.svg";
import ignitionOnIcon from "../../assets/ais_new_images/ignition.svg";
import ignitionOffIcon from "../../assets/ais_new_images/ignition_off.svg";
import stoppedIcon from "../../assets/ais_new_images/stopped.svg";
import temperingIcon from "../../assets/ais_new_images/tempering.svg";
import theftIcon from "../../assets/ais_new_images/theft.svg";
import geofenceInIcon from "../../assets/ais_new_images/geofencein.svg";
import geofenceOutIcon from "../../assets/ais_new_images/geofenceout.svg";
import notificationIcon from "../../assets/ais_new_images/notification.svg";
import tripStartIcon from "../../assets/ais_new_images/Trip Start.svg"
import tripEndIcon from "../../assets/ais_new_images/Trip End.svg"
import wireCutIcon from "../../assets/ais_new_images/Wire cut.svg"
import unAuthStopIcon from "../../assets/ais_new_images/Unauthorized Stop.svg"
import SourceExitSvg from "../../assets/ais_new_images/Source Exit.svg"
import MidpointEntrySvg from "../../assets/ais_new_images/Midpoint Entry.svg"
import MidpointExitSvg from "../../assets/ais_new_images/Midpoint Exit.svg"
import HarshAccelerationIcon from "../../assets/ais_new_images/Harsh Accelleration.svg";
import HarshBreakingIcon from "../../assets/ais_new_images/Harsh Braking.svg";

export {
  speedIcon,
  ignitionOnIcon,
  ignitionOffIcon,
  stoppedIcon,
  temperingIcon,
  theftIcon,
  alertsIcon,
  geofenceInIcon,
  geofenceOutIcon,
  notificationIcon,
  HarshBreakingIcon,
  HarshAccelerationIcon
};

export const WS_TYPE_TO_API_KEY = {
  ignitionOn: "IGNITION_ON",
  ignitionOff: "IGNITION_OFF",
  ignition: "IGNITION_ON",
  // overspeed: "OVER_SPEED_ALERT",
  deviceOverspeed: "OVER_SPEED_ALERT",
  speedLimit: "OVER_SPEED_ALERT",
  tampering: "TAMPERING_ALERT",
  tamperingAlert: "TAMPERING_ALERT",
  sos: "SOS",
  alarm: "SOS",
  geofenceEnter: "USER_IN_ALERT",
  geofenceExit: "USER_OUT_ALERT",
  powerCut: "TAMPERING_ALERT",
  parking: "OUT_ALERT",
  fuelDrop: "DEVICE_FUEL_DROP",
  fuelFill: "DEVICE_FUEL_REFILL",
  IGNITION_ON: "IGNITION_ON",
  IGNITION_OFF: "IGNITION_OFF",
  OVER_SPEED_ALERT: "OVER_SPEED_ALERT",
  TAMPERING_ALERT: "TAMPERING_ALERT",
  SOS: "SOS",
  USER_IN_ALERT: "USER_IN_ALERT",
  USER_OUT_ALERT: "USER_OUT_ALERT",
  OUT_ALERT: "OUT_ALERT",
  DEVICE_FUEL_DROP: "DEVICE_FUEL_DROP",
  DEVICE_FUEL_REFILL: "DEVICE_FUEL_REFILL",
  lockOpened: "LOCK_OPENED",
  lockClosed: "LOCK_CLOSED",
  lockTampered: "LOCK_TAMPERED",
  lockBatteryLow: "LOW_BATTERY",
  lockDisconnected: "LOCK_DISCONNECTED",
  // Portable lock websocket event types (raw.eventType values)
  DEVICE_UNLOCK: "LOCK_OPENED",
  DEVICE_LOCK: "LOCK_CLOSED",
  DEVIATION_ALERT: "ROUTE_DEVIATION_ALERT",
  TEMPERING_ALERT: "TAMPERING_ALERT", // note: backend's misspelling → your correctly-spelled GPS key
  UN_AUTH_STOPPAGE_ALERT: "UNAUTHORIZED_STOP_ALERT",
  HARSH_ACCELERATION_ALERT: "HARSH_ACCELERATION_ALERT",
  HARSH_BRAKING_ALERT: "HARSH_BRAKING_ALERT",
  harshAcceleration: "HARSH_ACCELERATION_ALERT",
  harshBraking: "HARSH_BRAKING_ALERT",
  // ── Exact backend event keys ──
  hardAcceleration: "HARSH_ACCELERATION_ALERT",
  hardBraking: "HARSH_BRAKING_ALERT",
  routeDeviation: "ROUTE_DEVIATION_ALERT",
  unAuthStop: "UNAUTHORIZED_STOP_ALERT",
  tripEnded: "TRIP_END",
  tripEnd: "TRIP_END",
  LOW_BATTERY_ALERT: "LOW_BATTERY",

};

const SvgIcon = ({ src }) => (
  <img src={src} style={{ width: 35, height: 35 }} alt="" />
);

// ══════════════════════════════════════════════════════════════════════
// GPS ALERTS CONFIGS
// ══════════════════════════════════════════════════════════════════════
export const ALERT_CONFIGS = {
  OVER_SPEED_ALERT: {
    label: "Over Speed Alert",
    icon: <SvgIcon src={speedIcon} />,
    color: "#dd6b20",
    bgColor: "rgba(221,107,32,0.1)",
  },
  IGNITION_ON: {
    label: "Ignition On",
    icon: <SvgIcon src={ignitionOnIcon} />,
    color: "#3182ce",
    bgColor: "rgba(49,130,206,0.1)",
  },
  IGNITION_OFF: {
    label: "Ignition Off",
    icon: <SvgIcon src={ignitionOffIcon} />,
    color: "#718096",
    bgColor: "rgba(113,128,150,0.1)",
  },
  OUT_ALERT: {
    label: "Theft Alert",
    icon: <SvgIcon src={theftIcon} />,
    color: "#e53e3e",
    bgColor: "rgba(229,62,62,0.1)",
  },
  TAMPERING_ALERT: {
    label: "Tampering Alert",
    icon: <SvgIcon src={temperingIcon} />,
    color: "#b7271a",
    bgColor: "rgba(183,39,26,0.1)",
  },
  SOS: {
    label: "SOS",
    icon: <SvgIcon src={alertsIcon} />,
    color: "#e53e3e",
    bgColor: "rgba(229,62,62,0.15)",
  },
  USER_IN_ALERT: {
    label: "Geofence In Alert",
    icon: <SvgIcon src={geofenceInIcon} />,
    color: "#2f855a",
    bgColor: "rgba(47,133,90,0.1)",
  },
  USER_OUT_ALERT: {
    label: "Geofence Out Alert",
    icon: <SvgIcon src={geofenceOutIcon} />,
    color: "#d69e2e",
    bgColor: "rgba(214,158,46,0.1)",
  },
  DEVICE_FUEL_REFILL: {
    label: "Fuel Fill Alert",
    icon: <SvgIcon src={notificationIcon} />,
    color: "#0077c2",
    bgColor: "rgba(0,119,194,0.1)",
  },
  DEVICE_FUEL_DROP: {
    label: "Fuel Drop Alert",
    icon: <SvgIcon src={notificationIcon} />,
    color: "#c05621",
    bgColor: "rgba(192,86,33,0.1)",
  },
  UNAUTHORIZED_STOP_ALERT: {
    label: "Unauthorized Stop",
    icon: <SvgIcon src={stoppedIcon} />,
    color: "#d97706",
    bgColor: "rgba(217,119,6,0.1)",
  },
  ROUTE_DEVIATION_ALERT: {
    label: "Route Deviation",
    icon: <SvgIcon src={notificationIcon} />,
    color: "#7c3aed",
    bgColor: "rgba(124,58,237,0.1)",
  },
  HARSH_ACCELERATION: {
    label: "Harsh Acceleration",
    icon: <SvgIcon src={HarshAccelerationIcon} />,
    color: "#b45309",
    bgColor: "rgba(49,130,206,0.1)",
  },
  HARSH_BREAKING: {
    label: "Harsh Braking",
    icon: <SvgIcon src={HarshBreakingIcon} />,
    color: "#dc2626",
    bgColor: "rgba(49,130,206,0.1)",
  },
  HARSH_ACCELERATION_ALERT: {
    label: "Harsh Acceleration",
    icon: <SvgIcon src={HarshAccelerationIcon} />,
    color: "#b45309",
    bgColor: "rgba(49,130,206,0.1)",
  },
  HARSH_BRAKING_ALERT: {
    label: "Harsh Braking",
    icon: <SvgIcon src={HarshBreakingIcon} />,
    color: "#dc2626",
    bgColor: "rgba(49,130,206,0.1)",
  },
  default: {
    label: "Notification",
    icon: <SvgIcon src={notificationIcon} />,
    color: "#082D6B",
    bgColor: "rgba(8,45,107,0.08)",
  },

  // ══════════════════════════════════════════════════════════════════════
  // LOCK ALERTS CONFIGS
  // ══════════════════════════════════════════════════════════════════════
  TEMPERING_ALERT: {
    label: "Tampering",
    bgColor: "#FEF2F2",
    color: "#DC2626",
  },
  WIRE_CUT: {
    label: "Wire Cut",
    bgColor: "#FEF3E2",
    color: "#EA580C",
  },
  UNAUTHORIZED_STOPS: {
    label: "Unauthorized Stop",
    bgColor: "#FEF3E2",
    color: "#F59E0B",
  },
  OVER_SPEED: {
    label: "Over Speed Alert",
    bgColor: "#F0FDF4",
    color: "#16A34A",
  },
  ROUTE_DEVIATION_ALERT: {
    label: "Route Deviation",
    bgColor: "#FEF2F2",
    color: "#DC2626",
  },
  LOCK_OPENED: {
    label: "Lock Opened",
    bgColor: "#ECE7FE",
    color: "#7C3AED",
  },
  TRIP_END: {
    label: "Trip End",
    bgColor: "#ECE7FE",
    color: "#7C3AED",
  },
  TRIP_START: {
    label: "Trip Start",
    bgColor: "#ECE7FE",
    color: "#3aed67",
  },
  LOW_BATTERY: {
    label: "Low Battery",
    bgColor: "#ECE7FE",
    color: "#ed9f3a",
  },

  LOCK_CLOSED: {
    label: "Lock Closed",
    bgColor: "#ECFDF5",
    color: "#16A34A",
  },
  LOW_BATTERY: {
    label: "Low Battery",
    bgColor: "#FEF3E2",
    color: "#EA580C",
  },
  LOCK_OFFLINE: {
    label: "Lock Offline",
    bgColor: "#F3F4F6",
    color: "#6B7280",
  },
  SOURCE_EXIT: { label: "Source Exit", bgColor: "#FEF2F2", color: "#DC2626" },
  DESTINATION_ENTRY: { label: "Destination Entry", bgColor: "#F0FDF4", color: "#16A34A" },
  MIDPOINT_ENTRY: { label: "Midpoint Entry", bgColor: "#EFF6FF", color: "#3182CE" },
  MIDPOINT_EXIT: { label: "Midpoint Exit", bgColor: "#FEF3E2", color: "#D97706" },

};

export const ALERT_BORDER = {
  // GPS
  OVER_SPEED_ALERT: "#dd6b20",
  IGNITION_ON: "#22c55e",
  IGNITION_OFF: "#94a3b8",
  OUT_ALERT: "#ef4444",
  TAMPERING_ALERT: "#b91c1c",
  SOS: "#ef4444",
  USER_IN_ALERT: "#16a34a",
  USER_OUT_ALERT: "#eab308",
  DEVICE_FUEL_REFILL: "#0284c7",
  DEVICE_FUEL_DROP: "#ea580c",
  UNAUTHORIZED_STOP_ALERT: "#d97706",
  ROUTE_DEVIATION_ALERT: "#7c3aed",
  HARSH_ACCELERATION_ALERT: "#b45309",
  HARSH_BRAKING_ALERT: "#dc2626",
  default: "#082D6B",

  // LOCK
  TEMPERING_ALERT: "#DC2626",
  WIRE_CUT: "#EA580C",
  UNAUTHORIZED_STOPS: "#F59E0B",
  OVER_SPEED: "#16A34A",
  ROUTE_DEVIATION_ALERT: "#DC2626",
  LOCK_OPENED: "#7C3AED",
  LOCK_CLOSED: "#16A34A",
  LOW_BATTERY: "#EA580C",
  LOCK_OFFLINE: "#6B7280",
  SOURCE_EXIT: "#DC2626",
  DESTINATION_ENTRY: "#16A34A",
  MIDPOINT_ENTRY: "#3182CE",
  MIDPOINT_EXIT: "#D97706",
};

// ══════════════════════════════════════════════════════════════════════
// LOCK ALERT SVG ICONS
// ══════════════════════════════════════════════════════════════════════
const LockIconWrap = ({ children }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {children}
  </svg>
);

export const TamperingSvg = ({ color = "#DC2626" }) => (
  <LockIconWrap>
    <path d="M12 3l8 4v5c0 5-3.5 8-8 9-4.5-1-8-4-8-9V7l8-4z" stroke={color} strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M12 8v5" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <circle cx="12" cy="16" r="1.1" fill={color} />
  </LockIconWrap>
);



export const OverSpeedSvg = ({ color = "#16A34A" }) => (
  <LockIconWrap>
    <path d="M4 15a8 8 0 0 1 16 0" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path d="M12 15l4.5-5.5" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <circle cx="12" cy="15" r="1.3" fill={color} />
  </LockIconWrap>
);

export const RouteDeviationSvg = ({ color = "#DC2626" }) => (
  <LockIconWrap>
    <path d="M4 18c4-8 6-10 8-10s3 3 3 6 1 6 3 6" stroke={color} strokeWidth="2" strokeLinecap="round" fill="none" />
    <circle cx="4" cy="18" r="1.5" fill={color} />
    <circle cx="18" cy="20" r="1.5" fill={color} />
  </LockIconWrap>
);

export const LockOpenedSvg = ({ color = "#7C3AED" }) => (
  <LockIconWrap>
    <rect x="5" y="11" width="14" height="10" rx="2" stroke={color} strokeWidth="1.8" />
    <path d="M8 11V7a4 4 0 0 1 7.5-1.9" stroke={color} strokeWidth="1.8" strokeLinecap="round" fill="none" />
    <circle cx="12" cy="16" r="1.3" fill={color} />
  </LockIconWrap>
);

export const LockClosedSvg = ({ color = "#16A34A" }) => (
  <LockIconWrap>
    <rect x="5" y="11" width="14" height="10" rx="2" stroke={color} strokeWidth="1.8" />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" stroke={color} strokeWidth="1.8" fill="none" />
    <circle cx="12" cy="16" r="1.3" fill={color} />
  </LockIconWrap>
);


export const LowBatterySvg = ({ color = "#EA580C" }) => (
  <LockIconWrap>
    <rect x="3" y="8" width="15" height="8" rx="1.8" stroke={color} strokeWidth="1.8" />
    <path d="M20 10.5v3" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
    <rect x="5.5" y="10.5" width="3" height="3" rx="0.5" fill={color} />
  </LockIconWrap>
);

export const LockOfflineSvg = ({ color = "#6B7280" }) => (
  <LockIconWrap>
    <path d="M8 8.5a5.5 5.5 0 0 1 8 0" stroke={color} strokeWidth="1.8" strokeLinecap="round" fill="none" />
    <path d="M6 11.3a8.5 8.5 0 0 1 12 0" stroke={color} strokeWidth="1.8" strokeLinecap="round" fill="none" opacity="0.5" />
    <circle cx="12" cy="16.5" r="1.4" fill={color} />
    <path d="M4 4l16 16" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
  </LockIconWrap>
);



export const DestinationEntrySvg = ({ color = "#16A34A" }) => (
  <LockIconWrap>
    <path d="M12 3c-3.3 0-6 2.7-6 6 0 4.5 6 12 6 12s6-7.5 6-12c0-3.3-2.7-6-6-6z" stroke={color} strokeWidth="1.8" fill="none" />
    <path d="M14.5 9h-4.5m0 0l1.8-1.8M10 9l1.8 1.8" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </LockIconWrap>
);


export const ALERT_ICON_SRC = {
  // GPS
  OVER_SPEED_ALERT: speedIcon,
  IGNITION_ON: ignitionOnIcon,
  IGNITION_OFF: ignitionOffIcon,
  OUT_ALERT: theftIcon,
  TAMPERING_ALERT: temperingIcon,
  SOS: alertsIcon,
  USER_IN_ALERT: geofenceInIcon,
  USER_OUT_ALERT: geofenceOutIcon,
  DEVICE_FUEL_REFILL: notificationIcon,
  DEVICE_FUEL_DROP: notificationIcon,
  UNAUTHORIZED_STOP_ALERT: unAuthStopIcon,
  ROUTE_DEVIATION_ALERT: notificationIcon,
  HARSH_ACCELERATION: HarshAccelerationIcon,
  HARSH_BREAKING: HarshBreakingIcon,
  HARSH_ACCELERATION_ALERT: HarshAccelerationIcon,
  HARSH_BRAKING_ALERT: HarshBreakingIcon,
  // LOCK - emoji
  WIRE_CUT: wireCutIcon,
  UNAUTHORIZED_STOP_ALERT: unAuthStopIcon,
  OVER_SPEED: <OverSpeedSvg />,
  ROUTE_DEVIATION_ALERT: <RouteDeviationSvg />,
  LOCK_OPENED: <LockOpenedSvg />,
  LOCK_CLOSED: <LockClosedSvg />,
  TRIP_START: tripStartIcon,
  TRIP_END: tripEndIcon,
  LOW_BATTERY: <LowBatterySvg />,
  LOCK_OFFLINE: <LockOfflineSvg />,
  SOURCE_EXIT: SourceExitSvg,
  DESTINATION_ENTRY: <DestinationEntrySvg />,
  MIDPOINT_ENTRY: MidpointEntrySvg,
  MIDPOINT_EXIT: MidpointExitSvg,
};

export const NOTIFICATION_TYPES = [
  { label: "SOS", value: "SOS" },
  { label: "Over Speed Alert", value: "OVER_SPEED_ALERT" },
  { label: "Ignition On", value: "IGNITION_ON" },
  { label: "Ignition Off", value: "IGNITION_OFF" },
  { label: "Parking / Anti-Theft Alert", value: "OUT_ALERT" },
  { label: "Tampering Alert", value: "TAMPERING_ALERT" },
  { label: "Geofence In Alert", value: "USER_IN_ALERT" },
  { label: "Geofence Out Alert", value: "USER_OUT_ALERT" },
  { label: "Unauthorized Stoppage", value: "UNAUTHORIZED_STOP_ALERT" },
  { label: "Route Deviation", value: "ROUTE_DEVIATION_ALERT" },
  { label: "Harsh Acceleration", value: "HARSH_ACCELERATION" },
  { label: "Harsh Breaking", value: "HARSH_BREAKING" },
];

export const STATUS_FILTERS = [
  { key: "all", label: "All" },
  { key: "open", label: "Open" },
  { key: "closed", label: "Resolved" },
  { key: "rejected", label: "Rejected" },
];

export const KPI_TYPES = [
  { type: "SOS", canImmobilize: true },
  { type: "OVER_SPEED_ALERT", canImmobilize: false },
  { type: "TAMPERING_ALERT", canImmobilize: true },
  { type: "OUT_ALERT", canImmobilize: true },
  { type: "USER_OUT_ALERT", canImmobilize: false },
  { type: "USER_IN_ALERT", canImmobilize: false },
  { type: "UNAUTHORIZED_STOP_ALERT", canImmobilize: true },
  { type: "ROUTE_DEVIATION_ALERT", canImmobilize: true },
];

export const TRAIL_COLOR = {
  resolve: "#2E7D32",
  reject: "#6A1B9A",
  immob: "#B71C1C",
  action: "#1976D2",
};

export const TRAIL_LABEL = {
  resolve: "✅ Resolved",
  reject: "✕ Rejected",
  immob: "🚫 Immobilized",
  action: "⚡ Actioned",
};

export const ALERT_TYPE_LABEL = {
  // GPS
  SOS: "SOS EMERGENCY",
  OVER_SPEED_ALERT: "OVER SPEED ALERT",
  TAMPERING_ALERT: "TAMPERING ALERT",
  OUT_ALERT: "THEFT ALERT",
  USER_IN_ALERT: "GEOFENCE IN ALERT",
  USER_OUT_ALERT: "GEOFENCE OUT ALERT",
  IGNITION_ON: "IGNITION ON",
  IGNITION_OFF: "IGNITION OFF",
  DEVICE_FUEL_REFILL: "FUEL REFILL ALERT",
  DEVICE_FUEL_DROP: "FUEL DROP ALERT",
  UNAUTHORIZED_STOP_ALERT: "UNAUTHORIZED STOPPAGE",
  ROUTE_DEVIATION_ALERT: "ROUTE DEVIATION",
  HARSH_ACCELERATION_ALERT: "HARSH ACCELERATION",
  HARSH_BRAKING_ALERT: "HARSH BRAKING",

  // LOCK
  TEMPERING_ALERT: "TAMPERING ALERT",
  WIRE_CUT: "WIRE CUT",
  UNAUTHORIZED_STOPS: "UNAUTHORIZED STOP",
  OVER_SPEED: "OVER SPEED",
  ROUTE_DEVIATION_ALERT: "ROUTE DEVIATION",
  LOCK_OPENED: "LOCK OPENED",
  LOCK_CLOSED: "LOCK CLOSED",
  LOW_BATTERY: "LOW BATTERY",
  LOCK_OFFLINE: "OFFLINE",
  SOURCE_EXIT: "SOURCE EXIT",
  DESTINATION_ENTRY: "DESTINATION ENTRY",
  MIDPOINT_ENTRY: "MIDPOINT ENTRY",
  MIDPOINT_EXIT: "MIDPOINT EXIT",
};

const DUMMY_DRIVER_MAP = {
  861100064900380: {
    name: "Sunil Nair",
    lic: "KA-2019-00123",
    exp: "5 yrs",
    phone: "9876543210",
  },
  MH12AB3344: {
    name: "Suresh Yadav",
    lic: "MH-2020-44521",
    exp: "4 yrs",
    phone: "9812340011",
  },
  UP32CD7721: {
    name: "Anjali Sharma",
    lic: "UP-2021-77831",
    exp: "3 yrs",
    phone: "9988776655",
  },
  RJ14EF4420: {
    name: "Mohit Verma",
    lic: "RJ-2018-55610",
    exp: "8 yrs",
    phone: "9001122334",
  },
  KA05GH6631: {
    name: "Priya Nair",
    lic: "KA-2022-31120",
    exp: "2 yrs",
    phone: "9123456780",
  },
  GJ01IJ2200: {
    name: "Vikram Singh",
    lic: "GJ-2017-88230",
    exp: "9 yrs",
    phone: "9345678901",
  },
  TN09KL8810: {
    name: "Deepak Rao",
    lic: "TN-2020-60011",
    exp: "5 yrs",
    phone: "9456789012",
  },
  HR26MN4421: {
    name: "Kavita Mehra",
    lic: "HR-2019-24450",
    exp: "5 yrs",
    phone: "9567890123",
  },
  DL08JX5521: {
    name: "Arjun Kapoor",
    lic: "DL-2021-09982",
    exp: "3 yrs",
    phone: "9711223344",
  },
};
const DEFAULT_DRIVER = { name: "Driver N/A", lic: "—", exp: "—", phone: "—" };

const DUMMY_EXTRA = {
  OVER_SPEED_ALERT: {
    recordedSpeed: "94 km/h",
    speedLimit: "60 km/h",
    excess: "+34 km/h",
    duration: "2 min 18 sec",
    distance: "3.6 km",
  },
  OUT_ALERT: {
    lastIgnition: "OFF since 11:20 AM",
    movement: "Vehicle moving (38 km/h)",
    batteryVoltage: "12.1V (Low)",
    lastKnownDriver: "Vikram Singh",
  },
  TAMPERING_ALERT: {
    disconnectTime: "12:41 PM",
    disconnectLoc: "Sector 62, Noida",
    reconnectTime: "12:48 PM",
    reconnectLoc: "Sector 63, Noida",
    movedInBetween: true,
    distMoved: "2.1 km",
    gapDuration: "7 min",
  },
};

export const getDriver = (deviceName) =>
  DUMMY_DRIVER_MAP[deviceName] || DEFAULT_DRIVER;
export const getExtra = (type) => DUMMY_EXTRA[type] || {};
export const getInitials = (name = "") =>
  name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .substring(0, 2)
    .toUpperCase();

export const formatEventTime = (time) => {
  if (!time) return "N/A";
  return new Date(time).toLocaleString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

export const toISOStart = (d) => (d ? `${d}T00:00:00.000` : null);
export const toISOEnd = (d) => (d ? `${d}T23:59:59.000` : null);
export const nowTime = () =>
  new Date().toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

export const todayStr = new Date().toISOString().split("T")[0];

let _wsSeq = 0;

export function normalizeNotification(raw) {
  if (raw?.notificationType) {
    const normalizedType =
      WS_TYPE_TO_API_KEY[raw.notificationType] || raw.notificationType;
    return {
      _id: `api-${raw.id ?? raw.notificationType}-${raw.eventTime}`,
      _source: "api",
      notificationType: normalizedType,
      message: raw.message || raw.notificationType,
      deviceName: raw.deviceName || "—",
      latitude: raw.latitude ?? null,
      longitude: raw.longitude ?? null,
      geofenceName: raw.geofenceName || "",
      eventTime: raw.eventTime,
      eventValue: raw?.eventValue,
      configureOverSpeedValue: raw?.configureOverSpeedValue,
      status: "open",
      trail: [],
      relay: false,
    };
  }

  let parsedPayload = null;
  try {
    parsedPayload = raw.payload ? JSON.parse(raw.payload) : null;
  } catch {
    /* ignore */
  }

  const wsType =
    raw?.eventType ||
    parsedPayload?.event?.attributes?.alarm ||
    raw?.attributes?.alarm ||
    raw?.type;

  let apiKey = WS_TYPE_TO_API_KEY[wsType] || null;

  // ── Fallback: infer type from message text when wsType doesn't map ──
  // ── Fallback: infer type from message text when wsType doesn't map ──
  console.log("apikey", raw, apiKey)
  if (!apiKey && raw?.message) {
    const msg = raw.message.toLowerCase();
    if (msg.includes("trip has ended") || msg.includes("trip end")) {
      apiKey = "TRIP_END";
    } else if (msg.includes("trip has started") || msg.includes("trip start")) {
      apiKey = "TRIP_START";
    } else if (msg.includes("source exit")) {
      apiKey = "SOURCE_EXIT";
    } else if (msg.includes("destination entry")) {
      apiKey = "DESTINATION_ENTRY";
    } else if (msg.includes("midpoint entry")) {
      apiKey = "MIDPOINT_ENTRY";
    } else if (msg.includes("midpoint exit")) {
      apiKey = "MIDPOINT_EXIT";
    } else if (msg.includes("route deviation")) {
      apiKey = "ROUTE_DEVIATION_ALERT";
    } else if (msg.includes("wire cut")) {
      apiKey = "WIRE_CUT";
    } else if (msg.includes("unauthorized stoppage") || msg.includes("unauthorized stop")) {
      apiKey = "UNAUTHORIZED_STOP_ALERT";
    } else if (msg.includes("harsh acceleration") || msg.includes("hard acceleration")) {
      apiKey = "HARSH_ACCELERATION_ALERT";
    } else if (msg.includes("harsh braking") || msg.includes("harsh breaking") || msg.includes("hard braking")) {
      apiKey = "HARSH_BRAKING_ALERT";
    } else if (msg.includes("low battery") || msg.includes("battery low")) {
      apiKey = "LOW_BATTERY";
    }
  }
  apiKey = apiKey || "default";

  const lat =
    parsedPayload?.position?.latitude ??
    raw?.position?.latitude ??
    raw?.latitude ??
    null;
  const lng =
    parsedPayload?.position?.longitude ??
    raw?.position?.longitude ??
    raw?.longitude ??
    null;

  // ── Fallback: parse "Lat: XX.XXX, Lon: YY.YYY" out of the message ──
  let msgLat = null, msgLng = null;
  if (raw?.message) {
    const latLonMatch = raw.message.match(
      /Lat:\s*(-?\d+\.?\d*)\s*,\s*Lon:\s*(-?\d+\.?\d*)/i,
    );
    if (latLonMatch) {
      msgLat = parseFloat(latLonMatch[1]);
      msgLng = parseFloat(latLonMatch[2]);
    }
  }

  // Fallback: pull the timestamp out of the message text when the
  // structured eventTime field isn't populated (e.g. portable-lock events).
  // Handles both "DD/MM/YYYY hh:mm AM/PM" and native-parseable formats.
  const timeMatch = raw?.message?.match(
    /(\d{2})\/(\d{2})\/(\d{4})\s+(\d{1,2}):(\d{2})\s*([APap][Mm])/,
  );
  let parsedTime = null;
  if (timeMatch) {
    const [, dd, mm, yyyy, hh, min, ampm] = timeMatch;
    let hour = parseInt(hh, 10);
    if (/pm/i.test(ampm) && hour !== 12) hour += 12;
    if (/am/i.test(ampm) && hour === 12) hour = 0;
    // dd/mm/yyyy → construct explicitly, don't rely on Date string parsing
    parsedTime = new Date(Number(yyyy), Number(mm) - 1, Number(dd), hour, Number(min));
  }

  const eventTime =
    parsedPayload?.event?.eventTime ??
    raw?.eventTime ??
    (parsedTime && !isNaN(parsedTime) ? parsedTime.toISOString() : null);

  // Match "vehicle number XXXX" or "lock number XXXX"
  const vehicleMatch = raw?.message?.match(
    /(?:vehicle|lock)\s+number\s+([A-Z0-9]+)/i,
  );
  const deviceName = vehicleMatch
    ? vehicleMatch[1]
    : raw?.deviceName || raw?.device?.name || "—";

  return {
    _id: `ws-${++_wsSeq}-${eventTime}`,
    _source: "ws",
    notificationType: apiKey,
    message: raw.message || wsType || "Notification",
    deviceName,
    latitude: lat ?? msgLat,
    longitude: lng ?? msgLng,
    geofenceName: raw.geofenceName || "",
    eventTime,
    eventValue: raw?.eventValue,
    configureOverSpeedValue: raw?.configureOverSpeedValue,
    status: "open",
    trail: [],
    relay: false,
  };
}
